(ns frontend.components.inputs.number
  (:require
   [frontend.components.inputs.footprint :refer [display-string editor viewer]]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.utils :as utils]
   [reagent.core :as r]))

(defn render
  [dom-atom args]
  (let [{:keys [:value :class-name :placeholder
                :has-focus?
                :on-focus! :on-blur! :on-change!
                :on-key-down! :disabled? :base-multiplier]}
        args
        value (if (fu/is-bigdec? value) (fu/bigdec->float value) value)
        raw-value (:temp-value @dom-atom)
        edit-decimals (if (nil? raw-value) -1 (get @dom-atom :decimal-count))
        edit-value (or raw-value value)
        edit-negative? (get @dom-atom :negative?)
        ;; We break pure function here - makes using the number formatter bit easier -- TODO: should we not do this ?
        base-multiplier (or base-multiplier
                            (some->> @session/tenant
                                     :tenant/cur-multiplier))
        clear-state! (fn []
                       (swap! dom-atom dissoc
                         :temp-value
                         :negative?
                         :cleared?))]
    [:input
     (merge {:ref         (fn [e]
                            (when (and e
                                       (not= e (:input-dom-node @dom-atom)))
                              (swap! dom-atom assoc :input-dom-node e)))
             :placeholder (or placeholder "")
             :type        "text"
             :class-name  (fu/cs "component-number" (when has-focus? "focus") class-name)
             :on-focus    (fn [e]
                            (.select (:input-dom-node @dom-atom)) ;; all desktop browsers - select all text
                            (when on-focus!
                              (on-focus! e)))
             :on-blur     (fn [e]
                            (when on-blur!
                              (on-blur! e edit-value clear-state!)))
             :value       (if-not has-focus?
                            (utils/format-number-with-mult value base-multiplier)
                            (let [draw-value edit-value
                                  min-decimal-count edit-decimals]
                              (or
                               (when draw-value
                                 (if (= draw-value "")
                                   (when edit-negative? "-")
                                   (utils/format-with-separators draw-value
                                                                 min-decimal-count
                                                                 edit-negative?))) ;; append decimal when editing without decimals
                               "")))
             :on-key-down on-key-down!
             :on-change   (fn [e]
                            (let [input (-> e
                                            .-target
                                            .-value)
                                  float-value (utils/parse-float-info input "")]
                              (swap! dom-atom assoc
                                :decimal-count (or (:decimal-count float-value) -1)
                                :negative? (or (:negative? float-value) false)
                                :temp-value (:float-value float-value))
                              (when on-change!
                                (on-change! e (:float-value float-value)))))}
            (when disabled?
              {:disabled (boolean disabled?)}))]))


(defmethod editor :editor.type/number
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                        ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Number"
      :component-did-mount    (fn [args]
                                (let []
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value)))) ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod display-string :editor.type/number
  [args]
  (let [value (:value args)
        base-multiplier (:base-multiplier args)]
    (cond (fu/is-bigdec? value)
          (fu/format-number-with-mult (fu/bigdec->float value)
                                      (or base-multiplier
                                          (some->> @session/tenant
                                                   :tenant/cur-multiplier)))
          (float? value)
          (fu/format-with-separators value 1 false 3)
          :else
          (str value))))

(defmethod viewer :editor.type/number
  [args]
  (r/create-class
   {:display-name   "number/viewer"
    :reagent-render (fn [args]
                      [:div.preview.preview-number
                       (display-string args)])}))
